<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-12-09 11:12:05
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-12-23 14:20:57
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/nesting/components/addCreditDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <!-- <div class="notice-content">
      <p class="">填写说明：</p>
      <p>
        <span> 1.以下信息均为必填项，请全部填写完成后提交； </span>
        <span
          >2.若供应商上传的企业审计报告不正确，请线下联系供应商进行更新，完成审计报告确认后，方可提交。</span
        >
      </p>
    </div> -->
    <div class="form-content">
      <p class="title">企业信用评价结果</p>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        label-width="200px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商名称：" prop="companyName">
              <span class="item-info">
                {{ ruleForm.companyName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书编号：" prop="certificateNo">
              <span class="item-info">
                {{ ruleForm.certificateNo }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期至：" prop="validDate">
              <div class="flex">
                <span class="item-info">
                  {{ ruleForm.certificateEffectiveBeginTime }}至{{
                    ruleForm.certificateEffectiveEndTime
                  }}
                </span>
                <el-checkbox
                  v-model="longTermEffective"
                  style="margin-left: 10px"
                  disabled
                  >长期有效</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="评价等级：" prop="evaluationLevel">
              <span class="item-info">
                {{ ruleForm.evaluationLevel }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="验证网址：" prop="checkWebSite">
              <span class="item-info">
                {{ ruleForm.checkWebSite }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="证书附件：" prop="certificateFile">
              <span class="item-info">
                <eui-btn
                  type="link"
                  @click="getDetail(ruleForm.certificateFile)"
                >
                  {{ ruleForm.certificateFileName }}</eui-btn
                >
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报告附件：" prop="reportFile">
              <span class="item-info">
                <eui-btn type="link" @click="getDetail(ruleForm.reportFile)">
                  {{ ruleForm.reportFileName }}</eui-btn
                >
              </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <p class="title">企业财务数据</p>
      <div>
        <companyData
          ref="companyData"
          :company-data="creditEvaluationDetail.financeList"
        ></companyData>
      </div>
      <p class="title">企业审计报告</p>
      <div class="report-content">
        <auditReport
          :report-list="creditEvaluationDetail.corporateAuditReportList"
        ></auditReport>
      </div>
    </div>
    <div class="footer-content">
      <eui-btn type="secondary" @click="goBack()">取消</eui-btn>
      <!-- <eui-btn type="secondary" @click="submitForm(1)">保存</eui-btn>
      <eui-btn @click="submitForm(2)">提交</eui-btn> -->
    </div>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/user/index';
import auditReport from './auditReportDetail.vue';
import companyData from './companyDataDetail.vue';

export default {
  components: { auditReport, companyData },
  props: {
    id: {
      type: Number,
      default: null,
    },
    creditEvaluationDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fileList: [],
      reportFileList: [],
      // longTermEffective: false,
      evaluationLevelOptions: [
        { label: 'AAA' },
        { label: 'AA' },
        { label: 'A' },
        { label: 'BBB' },
        { label: 'BB' },
        { label: 'B' },
        { label: 'CCC' },
        { label: 'CC' },
        { label: 'C' },
        { label: 'D' },
      ],
      ruleForm: {},

      reportList: [],
    };
  },

  computed: {
    longTermEffective() {
      return (
        this.creditEvaluationDetail.companyCreditEvaluationAO
          .longTermEffective === 1
      );
    },
  },

  created() {
    // console.log(this.creditEvaluationDetail);
    this.ruleForm = this.creditEvaluationDetail.companyCreditEvaluationAO;
  },
  mounted() {
    // console.log(this.creditEvaluationDetail, 'mounted');
  },
  methods: {
    async handleSelect(item) {
      console.log(item);
      console.log(this.ruleForm);
      this.ruleForm.companyId = item.id;
      const yearsList = this.$refs.companyData.getYearsList();
      await this.getReportList(yearsList);
    },

    // 获取审计报告
    async getReportList(yearsList) {
      yearsList.forEach(async (item) => {
        const params = {
          companyId: this.ruleForm.companyId,
          year: Number(item.value),
        };
        const res = await api.queryAuditReportByYear(params);
        if (res.code === '200') {
          this.reportList.push(res.data);
        }
      });
    },
    getDetail(url) {
      window.open(url);
    },
    goBack() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.notice-content {
  display: flex;
  flex-flow: row;
  background: #e8efff;
  padding: 15px 10px;
  p:first-child {
    color: $headline-color-num;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
  }
  p:last-child {
    display: flex;
    flex-flow: column;
    color: $font-color-text;
    font-size: 14px;
    // margin-left: 10px;
  }
}
.form-content {
  .title {
    color: $font-color-text;
    font-size: 14px;
    // line-height: 24px;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 20px;
  }
}
.upload-demo {
  // display: flex;
  // align-items: center;
}
.el-upload__tip {
  margin-left: 10px;
  display: inline-block;
  /* margin-top: 15px; */
  position: absolute;
  top: -3px;
}
.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-top: 20px; */
  /* margin-bottom: 20px; */
  position: fixed;
  bottom: 0;
  width: 800px;
  background: #fff;
  text-align: center;
  padding-bottom: 20px;
  z-index: 100;
}
.report-content {
  margin-bottom: 70px;
}
</style>
